import {
    LogoutOutlined,
    FileSearchOutlined,
    ProjectOutlined,
    UsergroupAddOutlined,
    ApartmentOutlined,
    ReloadOutlined,
    ShopOutlined,
    TagOutlined,
    ExportOutlined,
    ClockCircleOutlined,
    SyncOutlined,
    CheckCircleOutlined,
    CloseCircleOutlined,
    MinusCircleOutlined,
    HomeOutlined,
    ImportOutlined,
    CalendarOutlined,
    DashboardOutlined,
    DatabaseOutlined,
    HourglassOutlined,
    CodeSandboxOutlined,
    SortDescendingOutlined,
    SortAscendingOutlined
} from '@ant-design/icons';

export const DATE_FORMAT = {
    DDMMYYYY_FORMAT: "DD/MM/YYYY",
    YYYYMMDD_FORMAT: "YYYY-MM-DD",
    DDMM_FORMAT: "DD/MM",
    DD_MM_YYYY_FORMAT: "DD-MM-YYYY",
    YYYYMMDDHHMMSS_FORMAT: "YYYY-MM-DD HH:mm:ss",
    YYYYMMDDHHMMSS_FORMAT_2: "YYYY/MM/DD HH:mm:ss",
}

export const TYPE_MODAL = {
    ADD: "ADD",
    EDIT: "EDIT",
    DEL: "DEL",
    APPROVE: "APPROVE"
}

export const PASSWORD_DEFAULT = '123456asdfwer3';

export const LIST_MENU_SIDE_BAR = [
    
    {
        key: 'dashboard',
        path: "/dashboard",
        label: 'Dashboard',
        icon: <DashboardOutlined />,
        permission: [1,2]
    },
    {
        key: 'account',
        path: "/account",
        label: 'Quản lý tài khoản',
        icon: <UsergroupAddOutlined />,
        permission: [1]
    },
    {
        key: 'department',
        path: "/department",
        label: 'Quản lý phòng ban',
        icon: <ApartmentOutlined />,
        permission: [1]
    },
    {
        key: 'shop',
        path: "/shop",
        label: 'Quản lý TiktokShop',
        icon: <HomeOutlined />,
        permission: [1]
    },
    // {
    //     key: 'type-task',
    //     path: "/type-task",
    //     label: 'Quản lý loại task',
    //     icon: <SwitcherOutlined />,
    //     permission: [1,3,4]
    // },
    {
        key: 'supplier',
        path: "/supplier",
        label: 'Quản lý nhà in',
        icon: <ShopOutlined />,
        permission: [1,2]
    },
    {
        key: 'orders',
        path: "/orders",
        label: 'Đơn hàng',
        icon: <TagOutlined />,
        permission: [1,2,6]
    },
    // {
    //     key: 'fullfillment',
    //     path: "/fullfillment",
    //     label: 'Fullfillment',
    //     icon: <ExportOutlined />,
    //     permission: [1,2]
    // },
    // {
    //     key: 'for-supplier',
    //     path: "/for-supplier",
    //     label: 'For Supplier',
    //     icon: <ExportOutlined />,
    //     permission: [1,5]
    // },
    // {
    //     key: 'import-tracking',
    //     path: "/import-tracking",
    //     label: 'Import tracking',
    //     icon: <ImportOutlined />,
    //     permission: [1,5]
    // },
    // {
    //     key: 'tasks',
    //     path: "/tasks",
    //     label: 'Quản lý task',
    //     icon: <DiffOutlined />,
    //     permission: [1,3,4]
    // },
    {
        label: 'Quản lý SKU',
        icon: <CodeSandboxOutlined />,
        children: [
            {
                key: 'import-sku',
                path: "/import-sku",
                label: 'Import SKU',
                icon: <ImportOutlined />,
                permission: [1, 2]
            },
            {
                key: 'import-basecost',
                path: "/import-basecost",
                label: 'Import Base Cost',
                icon: <ImportOutlined />,
                permission: [1, 2]
            },
            {
                key: 'data-sku',
                path: "/data-sku",
                label: 'Data SKU',
                icon: <DatabaseOutlined />,
                permission: [1, 2]
            },
            
        ]
    },
    
    {
        label: 'Báo cáo',
        icon: <ProjectOutlined />,
        children: [
            {
                key: 'bao-cao-order',
                path: "/bao-cao-order",
                label: 'Báo cáo đơn hàng',
                icon: <FileSearchOutlined />,
                permission: [1, 2]
            },
            {
                key: 'report-order-by-seller',
                path: "/report-order-by-seller",
                label: 'BC đơn hàng seller',
                icon: <FileSearchOutlined />,
                permission: [1, 2]
            },
            {
                key: 'report-top10-seller',
                path: "/report-top10-seller",
                label: 'BC Top 10 seller',
                icon: <FileSearchOutlined />,
                permission: [1, 2]
            },
            
        ]
    },
    
    {
        key: 'doi-mat-khau',
        path: "/doi-mat-khau",
        label: 'Change Password',
        icon: <ReloadOutlined />,
        permission: [1, 2, 3, 4, 5]
    },
    {
        key: 'dang-xuat',
        path: "/dang-xuat",
        label: 'Logout',
        icon: <LogoutOutlined />,
        permission: [1, 2, 3, 4, 5, 6]
    },

];

export const requiredItem = [
    {
        required: true,
        message: 'Vui lòng không để trống'
    }
];


export const FORMAT_DATE = {
    YYYYMMDDHHMMSS: 'YYYY-MM-DD HH:mm:ss',
    YYYYMMDD: 'YYYY-MM-DD',
    DDMMYYYY: 'DD/MM/YYYY',
}

export const STATUS_ORDER = [
    {
        value: 'waiting',
        label: 'Waiting',
        type: [1]
    },
    {
        value: 'processing',
        label: 'Processing',
        type: [1]
    },
    {
        value: 'completed',
        label: 'Completed',
        type: [1]
    },
    {
        value: 'cancelled',
        label: 'Cancelled',
        type: [1]
    },
    
    
]
export const STATUS_COMMON_NAME = {
    supplier: "Cancelled",
    staff: "Cancelled by supplier",
} 
export const statusOrderMap = {
    // waiting: { icon: <ClockCircleOutlined spin />, color: "#b81c24", text: "Waiting" },
    waiting: { icon: <HourglassOutlined />, color: "#f6941c", text: "Waiting" },
    updating: { icon: <SyncOutlined />, color: "processing", text: "Updating" },
    processing: { icon: <SyncOutlined />, color: "processing", text: "Processing" },
    picked: { icon: <ExportOutlined />, color: "processing", text: "picked" },
    fullfillment: { icon: <CheckCircleOutlined />, color: "success", text: "Fullfillment" },
    hold: { icon: <CloseCircleOutlined />, color: "error", text: "Hold" },
    cancelled: { icon: <CloseCircleOutlined />, color: "error", text: "Cancel" },
    refund: { icon: <CloseCircleOutlined />, color: "error", text: "Refund" },
    resend: { icon: <CloseCircleOutlined />, color: "processing", text: "Resend" },
    shipping: { icon: <MinusCircleOutlined />, color: "processing", text: "Shipping" },
    delivered: { icon: <CheckCircleOutlined />, color: "success", text: "Delivered" },
    completed: { icon: <CheckCircleOutlined />, color: "success", text: "Completed" },
    failed_delivery: { icon: <CloseCircleOutlined />, color: "error", text: "Failed Delivery" },
    cancel_common: { icon: <CloseCircleOutlined />, color: "error", text: "Canceled" },
};
// export const statusOrderMap = {
//     pending: { icon: <ClockCircleOutlined />, color: "#f6941c", text: "Dừng sản xuất" },
//     designing: { icon: <SyncOutlined />, color: "processing", text: "Đang thiết kế" },
//     producing: { icon: <SyncOutlined />, color: "processing", text: "Đang sản xuất" },
//     completed: { icon: <CheckCircleOutlined />, color: "success", text: "Hoàn thành" },
//     cancelled: { icon: <CloseCircleOutlined />, color: "error", text: "Huỷ sản xuất" },
//     shipping: { icon: <MinusCircleOutlined />, color: "processing", text: "Đang vận chuyển" },
//     waiting: { icon: <ClockCircleOutlined spin />, color: "#b81c24", text: "Chờ xử lý" },
//     exporting: { icon: <ExportOutlined />, color: "#2f7b88", text: "Chờ gửi sản xuất" },
//     waiting_producing: { icon: <SyncOutlined />, color: "processing", text: "Chờ sản xuất" },
//     ship_success: { icon: <CheckCircleOutlined />, color: "success", text: "Vận chuyển thành công" },
//     ship_failed: { icon: <CloseCircleOutlined />, color: "error", text: "Vận chuyển thất bại" },
//     product_cancel: { icon: <CloseCircleOutlined />, color: "error", text: "Huỷ sản xuất" },
// };

export const STATUS_TASK = [
    {
        value: 'pending',
        label: 'Pending Assignment'
    },
    {
        value: 'waiting',
        label: 'Waiting Processing'
    },
    {
        value: 'processing',
        label: 'Processing'
    },
    {
        value: 'completed',
        label: 'Finished'
    },
    {
        value: 'cancelled',
        label: 'Cancelled'
    }
]

export const TYPE_EXPORT = [
    {
        value: 1,
        label: 'Đã có export time'
    },
    {
        value: 2,
        label: 'Chưa có export time'
    }
]

export const TYPE_EXPORT_TRACKING = [
    {
        value: 1,
        label: 'Have tracking number'
    },
    {
        value: 2,
        label: 'No tracking number'
    }
]

export const TYPE_TIME = [
    {
        value: 2,
        label: 'Export at'
    },
    {
        value: 1,
        label: 'Create at'
    }
]

export const PAGE_SIZE = [
    {
        value: 20,
        label: 20
    },
    {
        value: 30,
        label: 30
    },
    {
        value: 50,
        label: 50
    },
    {
        value: 70,
        label: 70
    },
    {
        value: 100,
        label: 100
    }
]

export const ROLE_PERMISSION = {
    ADMIN: "1",
    STAFF: "2",
}

export const STATUS_SHIPPING = [
    {
        value: 'transit',
        label: 'In Transit'
    },
    {
        value: 'pickup',
        label: 'Out for Delivery'
    },
    {
        value: 'undelivered',
        label: 'Failed Attempt'
    },
    {
        value: 'delivered',
        label: 'Delivered'
    },
    {
        value: 'exception',
        label: 'Exception'
    },
    {
        value: 'expired',
        label: 'Expired'
    },
    {
        value: 'notfound',
        label: 'Not Found'
    },
    {
        value: 'pending',
        label: 'Pending'
    }
]

export const OPTION_TIME = [
    {
        label: 'Today',
        value: 1,
        icon: <ClockCircleOutlined />,
    },
    {
        label: 'Yesterday',
        value: 2,
        icon: <CalendarOutlined />,
    },
    {
        label: 'Last 7 days',
        value: 3,
        icon: <CalendarOutlined />,
    },
    {
        label: 'This month',
        value: 4,
        icon: <CalendarOutlined />,
    },
    {
        label: 'Last month',
        value: 5,
        icon: <CalendarOutlined />,
    },
]

export const LIST_MONTH = [
    {
        label: 'Tháng 1',
        value: 0,
    },
    {
        label: 'Tháng 2',
        value: 1,
    },
    {
        label: 'Tháng 3',
        value: 2,
    },
    {
        label: 'Tháng 4',
        value: 3,
    },
    {
        label: 'Tháng 5',
        value: 4,
    },
    {
        label: 'Tháng 6',
        value: 5,
    },
    {
        label: 'Tháng 7',
        value: 6,
    },
    {
        label: 'Tháng 8',
        value: 7,
    },
    {
        label: 'Tháng 9',
        value: 8,
    },
    {
        label: 'Tháng 10',
        value: 9,
    },
    {
        label: 'Tháng 11',
        value: 10,
    },
    {
        label: 'Tháng 12',
        value: 11,
    },
]

export const TYPE_LOG_TASK = {
    EDIT_END_TIME: 'end_time',
    EDIT_COMPLETED_AT: 'completed_time',
}

export const HeaderTableCus = {
    header: {
        cell: (props) => (
            <th
                {...props}
                style={{
                    backgroundColor: '#1890ff', // Màu nền
                    color: '#fff', // Màu chữ
                    textAlign: 'center', // Căn giữa
                    fontWeight: 'bold', // Đậm chữ
                    fontSize: 15, // Kích thước chữ
                    height: 20, // Chiều cao của header (giảm xuống)
                    lineHeight: '10px', // Dòng chữ căn chỉnh theo chiều cao
                }}
            >
                {props.children}
            </th>
        ),
    },
};

export const TYPE_STATUS_SKU = [
    {
        value: 1,
        label: 'Đã có SKU'
    },
    {
        value: 0,
        label: 'Chưa có SKU'
    }
]

export const SORT_TYPE = [
    {
        value: 'newest',
        label: 'Newest',
        icon: <SortDescendingOutlined />
    },
    {
        value: 'oldest',
        label: 'Oldest',
        icon: <SortAscendingOutlined />
    }
]

export const RATE_EURO_TO_USD = 1.34;